import { TarabutFavicon } from "../../assets/svgs";
import { getBankFaviconAsSvg } from "../../utils/svgUtils";
import "./styles.scss";

const PingPongIcons = ({ providerId, loading }) => {
  const secondaryBankFavicon = getBankFaviconAsSvg(providerId);

  return (
    <div className={`ping-pong-icons-container ${loading ? "is-loading" : ""}`}>
      <img
        src={TarabutFavicon}
        alt="Tarabut Logo"
        className="icon first-image"
      />
      {secondaryBankFavicon ? (
        <img
          src={secondaryBankFavicon}
          alt={providerId}
          className="icon second-image"
        />
      ) : null}
    </div>
  );
};

export default PingPongIcons;
